import {
  cubeAdminCustomersWithAvailabilityRegionDimension,
  cubeAdminCustomersWithAvailabilityTotalMeasure,
  cubeAdminCustomersWithAvailabilityWithAvailMeasure,
} from "./cubeAdminCustomersWithAvailabilityModel";
import { fetchCubeLoad, getCubeDataOrThrow } from "./fetchCubeLoad";
import type { CubeFilter, CubeLoadQuery } from "./cubeQueryTypes";
import {
  parseCustomerAvailabilityByRegionRows,
  type CustomerAvailabilityByRegionRow,
} from "./parseCustomerAvailabilityByRegionRows";

export type { CustomerAvailabilityByRegionRow } from "./parseCustomerAvailabilityByRegionRows";

const buildRegionFilters = (regionEqual: string | undefined): CubeFilter[] => {
  if (regionEqual === undefined || regionEqual.length === 0) {
    return [];
  }
  return [
    {
      member: cubeAdminCustomersWithAvailabilityRegionDimension,
      operator: "equals",
      values: [regionEqual],
    },
  ];
};

export const loadCustomersWithProductAvailabilityByRegion = async (params: {
  cubeLoad: (query: CubeLoadQuery) => Promise<unknown>;
  regionEqual?: string;
}): Promise<CustomerAvailabilityByRegionRow[]> => {
  const { cubeLoad, regionEqual } = params;
  const json = await fetchCubeLoad({
    cubeLoad,
    query: {
      measures: [
        cubeAdminCustomersWithAvailabilityTotalMeasure,
        cubeAdminCustomersWithAvailabilityWithAvailMeasure,
      ],
      dimensions: [cubeAdminCustomersWithAvailabilityRegionDimension],
      filters: buildRegionFilters(regionEqual),
      limit: 5000,
    },
  });
  const rows = getCubeDataOrThrow(json);
  return parseCustomerAvailabilityByRegionRows(rows);
};
